// ---------------------------------------------------------------------------
// Rascunho de inscrição guardado no aparelho ("Continuar sua inscrição").
// O link com código dura 12 h, mas a participação pode fechar antes disso.
// Aqui a gente confere no banco se AINDA existe alguma modalidade do rascunho
// aberta AGORA (ativa + janela de inscrições) e se o evento não passou.
// Se fechou, o rascunho é apagado em silêncio e nada aparece na tela.
// ---------------------------------------------------------------------------

import { supabase } from './supabase';
import { lerInscricaoCodigo, limparInscricaoCodigo } from './inscricaoCodigo';

export interface RascunhoAberto {
  slug: string;
  codigo: string;
  nome: string;
  modalidades: number[];
}

interface JanelaModalidade {
  id: number;
  ativa: boolean | null;
  inscricoes_abrem_em: string | null;
  inscricoes_fecham_em: string | null;
}

function hora(iso: string | null): number | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  return Number.isFinite(t) ? t : null;
}

// A participação privada (codigo_acesso) também conta: basta a janela estar
// aberta e a modalidade ativa.
function abertaAgora(m: JanelaModalidade, agora: number): boolean {
  if (m.ativa !== true) return false;
  const abre = hora(m.inscricoes_abrem_em);
  const fecha = hora(m.inscricoes_fecham_em);
  if (abre !== null && agora < abre) return false;
  if (fecha !== null && agora >= fecha) return false;
  return true;
}

export async function lerRascunhoAberto(): Promise<RascunhoAberto | null> {
  const salvo = lerInscricaoCodigo();
  if (!salvo) return null;

  try {
    const [{ data: mods }, { data: ev }] = await Promise.all([
      supabase
        .from('modalidades')
        .select('id, ativa, inscricoes_abrem_em, inscricoes_fecham_em')
        .in('id', salvo.modalidades),
      supabase
        .from('eventos')
        .select('nome, slug, inicio_em, fim_em')
        .eq('slug', salvo.slug)
        .maybeSingle(),
    ]);

    const agora = Date.now();
    const lista = ((mods as JanelaModalidade[] | null) ?? []).filter((m) =>
      abertaAgora(m, agora),
    );

    const evento = ev as
      | { nome?: string; inicio_em?: string | null; fim_em?: string | null }
      | null;

    const fimDoEvento = hora(evento?.fim_em ?? null) ?? hora(evento?.inicio_em ?? null);
    const passou = fimDoEvento !== null && fimDoEvento < agora;

    if (lista.length === 0 || passou) {
      limparInscricaoCodigo();
      return null;
    }

    return {
      slug: salvo.slug,
      codigo: salvo.codigo,
      nome: evento?.nome ?? salvo.slug,
      modalidades: salvo.modalidades,
    };
  } catch {
    // Sem rede (ou banco fora): não apaga nada e não mostra o cartão.
    return null;
  }
}